/* ============================================
   WOUNDED WIZARD — THEME JS
   v2 — Wand Cursor + Infinite Scroll + Wishlist
   ============================================ */
(function () {
  'use strict';

  /* ── LOADING BAR ─────────────────────────── */
  var bar = document.createElement('div');
  bar.className = 'ww-loading-bar';
  document.body.prepend(bar);
  setTimeout(function () { bar.remove(); }, 1500);

  /* ═══════════════════════════════════════════
     WAND CURSOR
     Uses pre-made wand-cursor.png directly
     ═══════════════════════════════════════════ */
  function initWandCursor() {
    var cursorEl = document.createElement('img');
    cursorEl.id = 'ww-cursor';
    cursorEl.alt = '';
    cursorEl.setAttribute('aria-hidden', 'true');
    document.body.appendChild(cursorEl);

    document.addEventListener('mousemove', function (e) {
      cursorEl.style.left = e.clientX + 'px';
      cursorEl.style.top  = e.clientY + 'px';
    });

    document.addEventListener('mousedown', function () {
      document.body.classList.add('ww-cursor-clicking');
    });
    document.addEventListener('mouseup', function () {
      document.body.classList.remove('ww-cursor-clicking');
    });

    document.addEventListener('mouseleave', function () {
      cursorEl.style.opacity = '0';
    });
    document.addEventListener('mouseenter', function () {
      cursorEl.style.opacity = '1';
    });

    // Use the Liquid-injected URL for the pre-made cursor
    var wandUrl = window.__ww_wand_url || '';
    if (wandUrl) {
      cursorEl.src = wandUrl;
      cursorEl.onload = function () {
        document.body.classList.add('ww-cursor-ready');
      };
      cursorEl.onerror = function () {
        // Fallback to CSS cursor
        document.body.style.cursor = 'url(' + wandUrl + ') 4 4, auto';
      };
    }
  }

  // Only init wand cursor on non-touch devices
  if (!('ontouchstart' in window)) {
    initWandCursor();
  }

  /* ── HAMBURGER MENU ──────────────────────── */
  var hamburger   = document.getElementById('ww-hamburger');
  var menu        = document.getElementById('ww-menu');
  var menuClose   = document.getElementById('ww-menu-close');
  var menuOverlay = document.getElementById('ww-menu-overlay');

  function openMenu() {
    menu.setAttribute('aria-hidden', 'false');
    hamburger.setAttribute('aria-expanded', 'true');
    hamburger.classList.add('open');
    document.body.classList.add('menu-open');
    if (menuClose) menuClose.focus();
  }

  function closeMenu() {
    menu.setAttribute('aria-hidden', 'true');
    hamburger.setAttribute('aria-expanded', 'false');
    hamburger.classList.remove('open');
    document.body.classList.remove('menu-open');
    if (hamburger) hamburger.focus();
  }

  if (hamburger)   hamburger.addEventListener('click', openMenu);
  if (menuClose)   menuClose.addEventListener('click', closeMenu);
  if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu && menu.getAttribute('aria-hidden') === 'false') {
      closeMenu();
    }
  });

  /* ── SCROLL TO TOP ───────────────────────── */
  var scrollBtn = document.getElementById('ww-scroll-top');
  if (scrollBtn) {
    window.addEventListener('scroll', function () {
      scrollBtn.classList.toggle('visible', window.scrollY > 400);
    }, { passive: true });
    scrollBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ── TOAST ───────────────────────────────── */
  function showToast(msg) {
    var t = document.getElementById('ww-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* ── WISHLIST ────────────────────────────── */
  var WL_KEY = 'ww_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; }
    catch (e) { return []; }
  }

  function saveWishlist(list) {
    try { localStorage.setItem(WL_KEY, JSON.stringify(list)); }
    catch (e) {}
  }

  function toggleWishlist(id, btn) {
    var list = getWishlist();
    var idx = list.indexOf(id);
    if (idx === -1) {
      list.push(id);
      btn.classList.add('active');
      btn.innerHTML = '&#9829;';
      btn.setAttribute('aria-label', 'Remove from wishlist');
      showToast('Added to wishlist ♥');
    } else {
      list.splice(idx, 1);
      btn.classList.remove('active');
      btn.innerHTML = '&#9825;';
      btn.setAttribute('aria-label', 'Add to wishlist');
      showToast('Removed from wishlist');
    }
    saveWishlist(list);
  }

  function attachWishlistButtons() {
    var wl = getWishlist();
    document.querySelectorAll('.ww-wishlist-btn[data-product-id]').forEach(function (btn) {
      if (btn._ww_attached) return;
      btn._ww_attached = true;
      var id = btn.dataset.productId;
      if (wl.includes(id)) {
        btn.classList.add('active');
        btn.innerHTML = '&#9829;';
      }
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleWishlist(id, btn);
      });
    });
  }

  /* ── HEADER SHADOW ───────────────────────── */
  var header = document.querySelector('.ww-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 60
        ? '0 4px 30px rgba(0,0,0,0.5)'
        : 'none';
    }, { passive: true });
  }

  /* ═══════════════════════════════════════════
     INFINITE SCROLL
     Watches a sentinel element; when visible,
     fetches the next page URL and appends cards
     ═══════════════════════════════════════════ */
  function initInfiniteScroll() {
    var grid      = document.getElementById('ww-infinite-grid');
    var sentinel  = document.getElementById('ww-scroll-sentinel');
    var indicator = document.getElementById('ww-load-more-indicator');
    var allLoaded = document.getElementById('ww-all-loaded');
    var nextLink  = document.getElementById('ww-next-page');

    if (!grid || !sentinel) return;

    var loading = false;
    var done    = !nextLink;

    if (done && allLoaded) {
      allLoaded.style.display = 'block';
    }

    function loadNextPage() {
      if (loading || done) return;
      loading = true;

      var nextUrl = nextLink ? nextLink.getAttribute('href') : null;
      if (!nextUrl) {
        done = true;
        if (allLoaded) allLoaded.style.display = 'block';
        if (indicator) indicator.style.display = 'none';
        return;
      }

      if (indicator) indicator.style.display = 'flex';

      fetch(nextUrl)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc    = parser.parseFromString(html, 'text/html');

          // Grab the new product cards (supports both regular and pop-culture cards)
          var newGrid = doc.getElementById('ww-infinite-grid');
          if (newGrid) {
            var cards = newGrid.querySelectorAll('.ww-card, .ww-pop-card');
            var cardIndex = grid.querySelectorAll('.ww-card, .ww-pop-card').length;
            cards.forEach(function (card, i) {
              // For pop cards, assign float animation delays
              if (card.classList.contains('ww-pop-card')) {
                var idx = (cardIndex + i) % 8;
                card.style.setProperty('--float-delay', (idx * 0.6) + 's');
                card.style.setProperty('--float-duration', ((idx % 3) + 4) + 's');
              }
              // Animate in
              card.style.opacity = '0';
              card.style.transform = 'translateY(16px)';
              grid.appendChild(card);
              requestAnimationFrame(function () {
                card.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
                card.style.opacity = '1';
                card.style.transform = 'translateY(0)';
                // Clear inline styles after animation so CSS animations (pop-float) can take over
                setTimeout(function () {
                  card.style.transition = '';
                  card.style.opacity = '';
                  card.style.transform = '';
                }, 450);
              });
            });
          }

          // Update next page link
          var newNextLink = doc.getElementById('ww-next-page');
          if (newNextLink) {
            if (nextLink) {
              nextLink.setAttribute('href', newNextLink.getAttribute('href'));
            }
          } else {
            // No more pages
            done = true;
            if (nextLink) nextLink.remove();
            nextLink = null;
            if (allLoaded) allLoaded.style.display = 'block';
          }

          if (indicator) indicator.style.display = 'none';
          loading = false;

          // Re-attach wishlist buttons to new cards
          attachWishlistButtons();
        })
        .catch(function (err) {
          console.warn('WW Infinite Scroll: fetch failed', err);
          loading = false;
          if (indicator) indicator.style.display = 'none';
        });
    }

    // Intersection observer on sentinel
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !done && !loading) {
            loadNextPage();
          }
        });
      }, { rootMargin: '200px' });

      observer.observe(sentinel);
    }
  }

  /* ═══════════════════════════════════════════
     SPLIT HERO — LIGHTNING TRANSITION (BOTH PANELS)
     ═══════════════════════════════════════════ */
  function initPortalTransition() {
    var pastPanel = document.getElementById('panel-past');
    var futurePanel = document.getElementById('panel-future');
    var overlay = document.getElementById('ww-lightning-overlay');
    if (!overlay) return;

    function triggerLightning(href) {
      overlay.classList.add('active');
      overlay.style.opacity = '1';
      document.body.style.animation = 'screen-shake 0.4s ease-out';

      // Force wizard visible via JS after flash goes dark
      var wizImg = document.getElementById('ww-wizard-img');
      if (wizImg) {
        setTimeout(function () {
          wizImg.style.opacity = '1';
          wizImg.style.transform = 'translate(-50%, -50%) scale(1)';
          wizImg.style.transition = 'opacity 0.4s, transform 0.4s';
        }, 600);
      }

      setTimeout(function () {
        window.location.href = href;
      }, 1800);
    }

    if (pastPanel) {
      pastPanel.addEventListener('click', function (e) {
        e.preventDefault();
        triggerLightning(pastPanel.getAttribute('href'));
      });
    }

    if (futurePanel) {
      futurePanel.addEventListener('click', function (e) {
        e.preventDefault();
        triggerLightning(futurePanel.getAttribute('href'));
      });
    }

    // Fix back button stuck: clear overlay when returning from bfcache
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        overlay.classList.remove('active');
        overlay.style.opacity = '0';
        document.body.style.animation = '';
        var wizImg = document.getElementById('ww-wizard-img');
        if (wizImg) {
          wizImg.style.opacity = '';
          wizImg.style.transform = '';
          wizImg.style.transition = '';
        }
      }
    });
  }

  /* ── DOMContentLoaded INIT ───────────────── */
  document.addEventListener('DOMContentLoaded', function () {

    attachWishlistButtons();
    initInfiniteScroll();
    initPortalTransition();

    /* Gallery thumbnails */
    var thumbs  = document.querySelectorAll('.ww-gallery__thumb');
    var mainImg = document.getElementById('ww-gallery-main-img');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (mainImg) {
          mainImg.src = thumb.dataset.src;
          mainImg.alt = thumb.dataset.alt || '';
        }
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });

    /* Variant picker */
    var variantData   = document.getElementById('ww-product-variants');
    var variantIdInput = document.getElementById('ww-variant-id');
    var atcBtn        = document.getElementById('ww-atc-btn');
    var priceEl       = document.getElementById('ww-product-price');

    if (variantData && variantIdInput) {
      var variants = JSON.parse(variantData.textContent);

      function findVariant(selectedOptions) {
        return variants.find(function (v) {
          return v.options.every(function (opt, i) {
            return opt === selectedOptions[i];
          });
        });
      }

      function getSelectedOptions() {
        var options = [];
        document.querySelectorAll('.ww-variant-group').forEach(function (group) {
          var active = group.querySelector('.ww-variant-pill.active');
          if (active) options.push(active.dataset.value);
        });
        return options;
      }

      document.querySelectorAll('.ww-variant-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          var idx = pill.dataset.optionIndex;
          document.querySelectorAll('[data-option-index="' + idx + '"]').forEach(function (p) {
            p.classList.remove('active');
          });
          pill.classList.add('active');

          var selectedLabel = document.getElementById('ww-option-selected-' + (parseInt(idx) + 1));
          if (selectedLabel) selectedLabel.textContent = pill.dataset.value;

          var matched = findVariant(getSelectedOptions());
          if (matched) {
            variantIdInput.value = matched.id;
            if (priceEl) {
              var price = (matched.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
              priceEl.innerHTML = '<span class="ww-price--regular">' + price + '</span>';
            }
            if (atcBtn) {
              if (matched.available) {
                atcBtn.disabled = false;
                atcBtn.classList.remove('ww-btn--disabled');
                atcBtn.textContent = 'Add to Cart';
              } else {
                atcBtn.disabled = true;
                atcBtn.classList.add('ww-btn--disabled');
                atcBtn.textContent = 'Sold Out';
              }
            }
          }
        });
      });
    }

    /* Sticky ATC */
    var stickyAtc  = document.querySelector('.ww-sticky-atc');
    var mainAtcBtn = document.getElementById('ww-atc-btn');

    if (stickyAtc && mainAtcBtn) {
      var stickyAtcBtn = stickyAtc.querySelector('.ww-sticky-atc__btn');

      var atcObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyAtc.classList.toggle('visible', !entry.isIntersecting);
          stickyAtc.setAttribute('aria-hidden', String(entry.isIntersecting));
        });
      }, { threshold: 0.5 });
      atcObserver.observe(mainAtcBtn);

      if (stickyAtcBtn) {
        stickyAtcBtn.addEventListener('click', function () { mainAtcBtn.click(); });
      }
    }

    /* Accordions */
    document.querySelectorAll('.ww-accordion__toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        var body   = document.getElementById(toggle.getAttribute('aria-controls'));
        var icon   = toggle.querySelector('.ww-accordion__icon');
        toggle.setAttribute('aria-expanded', String(!isOpen));
        if (body) body.classList.toggle('ww-accordion__body--closed', isOpen);
        if (icon) icon.textContent = isOpen ? '+' : '−';
      });
    });

    /* Size guide modal */
    var sizeModal = document.getElementById('ww-size-modal');
    document.querySelectorAll('.ww-size-guide-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        if (sizeModal) sizeModal.classList.add('open');
      });
    });
    if (sizeModal) {
      sizeModal.querySelector('.ww-size-modal__close').addEventListener('click', function () {
        sizeModal.classList.remove('open');
      });
      sizeModal.addEventListener('click', function (e) {
        if (e.target === sizeModal) sizeModal.classList.remove('open');
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sizeModal && sizeModal.classList.contains('open')) {
        sizeModal.classList.remove('open');
      }
    });

    /* Recently viewed */
    initRecentlyViewed();

    /* Cart quantity buttons */
    document.querySelectorAll('.ww-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key   = btn.dataset.key;
        var input = document.querySelector('.ww-qty-input[data-key="' + key + '"]');
        if (!input) return;
        var val = parseInt(input.value) || 1;
        input.value = btn.dataset.action === 'increase' ? val + 1 : Math.max(0, val - 1);
      });
    });

    /* Cart remove */
    document.querySelectorAll('.ww-cart-item__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key   = btn.dataset.key;
        var input = document.querySelector('.ww-qty-input[data-key="' + key + '"]');
        if (input) {
          input.value = 0;
          input.closest('form').submit();
        }
      });
    });

  }); // end DOMContentLoaded

  /* ── RECENTLY VIEWED ─────────────────────── */
  function initRecentlyViewed() {
    var RV_KEY = 'ww_rv';
    var MAX    = 8;

    function getRV() {
      try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; }
      catch (e) { return []; }
    }

    var isProduct = window.location.pathname.indexOf('/products/') !== -1;
    var handle    = isProduct
      ? window.location.pathname.split('/products/')[1].split('?')[0].split('/')[0]
      : null;

    if (handle) {
      var title  = (document.querySelector('.ww-product-info__title') || {}).textContent || '';
      var imgEl  = document.querySelector('.ww-gallery__main img');
      var imgSrc = imgEl ? imgEl.src : '';

      var list = getRV().filter(function (v) { return v.handle !== handle; });
      list.unshift({ handle: handle, title: title.trim(), imgSrc: imgSrc });
      if (list.length > MAX) list = list.slice(0, MAX);
      try { localStorage.setItem(RV_KEY, JSON.stringify(list)); } catch (e) {}
    }

    var container = document.getElementById('ww-recently-viewed');
    if (!container) return;

    var toShow = getRV().filter(function (v) { return v.handle !== handle; }).slice(0, 4);
    if (toShow.length === 0) return;

    var html = '<p class="ww-rv-title">★ Recently Viewed ★</p>';
    html += '<div class="ww-product-grid" style="--cols:4;">';
    toShow.forEach(function (v) {
      html += '<a href="/products/' + v.handle + '" style="text-decoration:none;">';
      html += '<div class="ww-card">';
      if (v.imgSrc) {
        html += '<div class="ww-card__media"><img src="' + v.imgSrc + '" alt="' + (v.title || '') + '" width="300" height="300" loading="lazy" class="ww-card__img"></div>';
      }
      html += '<div class="ww-card__info"><h3 class="ww-card__title">' + (v.title || '') + '</h3></div>';
      html += '</div></a>';
    });
    html += '</div>';
    container.innerHTML = html;
  }

})();
